import { cn } from '@/lib/utils'
import type { ReactNode } from 'react'

export interface IntuiLabelProps {
  htmlFor?: string
  children: ReactNode
  required?: boolean
  disabled?: boolean
  className?: string
}

function IntuiLabel({ htmlFor, children, required, disabled, className }: IntuiLabelProps) {
  return (
    <label htmlFor={htmlFor} className={cn('text-sm font-medium leading-none', disabled && 'cursor-not-allowed opacity-70', className)}>
      {children}
      {required && <span className="text-destructive ml-0.5" aria-hidden="true">*</span>}
    </label>
  )
}

export { IntuiLabel }
